import { useEffect, useState } from "react";
import useApi from "../../../api";
import { NXForm, Select } from "../../common";
import { toast } from "react-toastify";
import enumChoice from "../../../enum";
import { NxtbnDrawer } from "../../../components";
import { NXSearch, NXDelete } from "../../../icons";
import ProductChooser from './productChooser';
import ShippingChooser from './shippingChooser';
import DiscountChooser from './discountChooser';
import AsyncSelectStyled from "../../asyncSelectStyled";
import OrderDetails from "../orderDetails";
import { set } from "date-fns";
import AddressForm from "./addressForm";
import ProductWithVariantSearch from "../../common/productWithVariantSearchField";

function CreateOrderForm({
  isOpen,
  onClose,
}: {
  isOpen: boolean;
  onClose: () => void;
}) {
  const api = useApi();
  const [cartItems, setCartItems] = useState<any>({
    variants: []
  });

  const [orderEastiamte, setorderEastiamte] =  useState<any>({});

  const [openShippingModal, setOpenShippingModal] = useState(false);
  const [openDiscountgModal, setOpenDiscountModal] = useState(false);
  const [openOrderDetails, setOpenOrderDetails] = useState<any>(null);
  const [openShippingAddress, setOpenShippingAddress] = useState(false);
  const [openBillingAddress, setOpenBillingAddress] = useState(false);

  const [customer, setCustomer] = useState<any>();
  const [errorData, setErrorData] = useState<any>({});

  const orderHandle = (e: any) => {
    e.preventDefault();
    if (cartItems.variants.length === 0) {
      setErrorData({ error: ["You must add one or more products to your cart."] });
      return;
    }

    api.createOrder(cartItems).then((response: any) => {
      toast.success("Order created successfully");
      setOpenOrderDetails(response.order_alias);
      setErrorData({});
      setorderEastiamte({});
      setCartItems({ variants: [] });
      }, (error) => {
        setErrorData(error.response.data)
      })
  };

  
  

  const orderEastiamteHandler = (prePayload: any) => {
    api.orderEastiamte(prePayload).then((response) => {
      setorderEastiamte(response);
      setErrorData({});
    }, (error) => {
      setErrorData(error.response.data)
    })
  }
  
  
  
  

  useEffect(() => {
    if (cartItems.variants.length > 0) {
      orderEastiamteHandler(cartItems)
    }
  }, [cartItems]);

  const onShippingApply = (data: any, isCustom: boolean) => {
    setOpenShippingModal(!openShippingModal);
  
    if (isCustom) {
      // Remove 'shipping_method_id' if it exists and set 'custom_shipping_amount'
      const { shipping_method_id, ...rest } = cartItems;
      setCartItems({
        ...rest,
        custom_shipping_amount: data,
      });
    } else {
      // Remove 'custom_shipping_amount' if it exists and set 'shipping_method_id'
      const { custom_shipping_amount, ...rest } = cartItems;
      setCartItems({
        ...rest,
        shipping_method_id: data.shipping_method.id,
      });
    }
  };

  const onDiscountApply = (data: any, isCustom: boolean) => {
    setOpenDiscountModal(!openDiscountgModal);
  
    if (isCustom) {
      // Remove 'promocode' if it exists and set 'custom_shipping_amount'
      const { promocode, ...rest } = cartItems;
      setCartItems({
        ...rest,
        custom_discount_amount: data,
      });
    } else {
      // Remove 'custom_shipping_amount' if it exists and set 'promocode'
      const { custom_discount_amount, ...rest } = cartItems;
      setCartItems({
        ...rest,
        promocode: data.promo_code.value,
      });
    }
  };

  const onAddressSubmit = (data: any, isShipping: boolean) => {
    if (isShipping) {
      setCartItems({
        ...cartItems,
        shipping_address: data,
      });
    } else {
      setCartItems({
        ...cartItems,
        billing_address: data,
      });
    }
  }
  



  const handleCustomerChange = (selectedOption: any) => {
    setCustomer(selectedOption);
    if (selectedOption) {
      const shipping_address = {
        city: selectedOption?.default_shipping_address?.city,
        country: selectedOption?.default_shipping_address?.country,
        state: selectedOption?.default_shipping_address?.state,
        postal_code: selectedOption?.default_shipping_address?.postal_code,
        street_address: selectedOption?.default_shipping_address?.street_address,
      };

      const billing_address = {
        city: selectedOption?.default_billing_address?.city,
        country: selectedOption?.default_billing_address?.country,
        state: selectedOption?.default_billing_address?.state,
        postal_code: selectedOption?.default_billing_address?.postal_code,
        street_address: selectedOption?.default_billing_address?.street_address,
      }

      setCartItems({ ...cartItems, shipping_address: shipping_address, billing_address: billing_address, customer_id: selectedOption.id });
    } else {
      // Remove shipping_address if selectedOption is null
      const { shipping_address, billing_address, customer_id, ...rest } = cartItems; // Destructure to remove shipping_address
      setCartItems(rest); // Set the state without shipping_address
    }
  };
  

  const fetchOptions = async (inputValue: any) => {
    const params = {
      search: inputValue
    };
    const response = await api.getCustomerList(params) as any;  
    return response.results.map((item: any) => {
      const label = item?.first_name && item?.last_name 
        ? `${item?.first_name} ${item?.last_name} - ${item?.username}` 
        : item?.username;
        
      return { label, value: item.id, ...item };
    });
  };

  const onVariantChange = (variantData: any[]) =>  {
    setCartItems((prevItems: any) => {
      return {
        ...prevItems,
        variants: variantData,
      };
    });
  }
  

  return (
    <NxtbnDrawer title="Create Order" isOpen={isOpen} onClose={onClose}>
      
     
      {/* Customer Selection Section */}
      <div>
        <h2 className="text-lg font-semibold mb-2">Select Customer</h2>
        <AsyncSelectStyled
          loadOptions={fetchOptions}
          onChange={handleCustomerChange}
          isClearable={true}
          // placeholder="Select a customer"
          addComponentName="customer"
        />
      </div>

      {/* if no customer add buttion to fix address and shoppng address in form */}
       {!cartItems.customer_id && (
        <div className="mb-6">
          <button 
            onClick={() => {
              setOpenShippingAddress(true);
              setOpenBillingAddress(false);
            }} 
            type="button" 
            className="mr-3 text-blue-600 text-sm"
          >
            Add Shipping Address
          </button>
          <button 
            onClick={() => {
              setOpenBillingAddress(true);
              setOpenShippingAddress(false);
            }} 
            type="button" 
            className="ml-3 text-blue-600 text-sm"
          >
            Add Billing Address
          </button>
        </div>
      )}

      {/* Product Table */}
    <NXForm
      className="p-2 overflow-x-auto h-[90vh]"
      onSubmit={orderHandle}
      nonFieldError={errorData}
      showErrorPopup={true}
      >
        
        <div className="flex justify-between">
          {cartItems.shipping_address && (
            <div className="bg-white p-4 rounded-lg shadow border-b mb-4">
              <h2 className="text-lg font-semibold mb-4">Shipping Address</h2>
              <div className="space-y-1 text-left">
              <p>{cartItems?.shipping_address?.first_name || ''} {cartItems?.shipping_address?.last_name || ''}</p>
                <p>{cartItems.shipping_address.street_address}</p>
                <p>
                  {cartItems.shipping_address.city}, {cartItems.shipping_address.state} {cartItems.shipping_address.postal_code}
                </p>
                <p>{cartItems.shipping_address.country}</p>
              </div>

              {!cartItems.customer_id &&  <button  onClick={() => {
                setOpenBillingAddress(false);
                setOpenShippingAddress(true);
              }} 
              type="button"
              className="text-blue-600 text-sm">Edit</button>}
            </div>
          )}


          {cartItems.billing_address && (
            <div className="bg-white p-4 rounded-lg shadow border-b mb-4">
              <h2 className="text-lg font-semibold mb-4">Billing Address</h2>
              <div className="space-y-1 text-left">
                <p>{cartItems.billing_address.first_name || ''} {cartItems.billing_address.last_name || ''}</p>
                <p>{cartItems.billing_address.street_address}</p>
                <p>
                  {cartItems.billing_address.city}, {cartItems.billing_address.state} {cartItems.billing_address.postal_code}
                </p>
                <p>{cartItems.billing_address.country}</p>
              </div>
              {!cartItems.customer_id &&  <button  onClick={() => {
                setOpenBillingAddress(true);
                setOpenShippingAddress(false);
              }} 
              type="button"
              className="text-blue-600 text-sm">Edit</button>}
            </div>
          )}
        </div>
        

        <ProductWithVariantSearch usedIn='order' onVariantChange={onVariantChange} />

      
      {/* Payment section */}
        <div className="bg-white p-4 rounded-lg shadow border-t mt-10">
          <h2 className="text-lg font-semibold mb-4">Payment</h2>
          <div className="space-y-2">
            <div className="flex justify-between">
              <span className="w-1/2 text-left">Subtotal</span>
              <span className="w-1/4 text-right">{orderEastiamte.total_items} items</span>
              <span className="w-1/4 text-right">{orderEastiamte.subtotal}</span>
            </div>
            <div className="flex justify-between">
              <button type="button" onClick={() => setOpenDiscountModal(!openDiscountgModal)} className="w-1/2 text-left text-blue-600">Add discount</button>
              <span className="w-1/4 text-right">{orderEastiamte.discount_percentage}</span>
              <span className="w-1/4 text-right">{orderEastiamte.discount}</span>
            </div>
            <div className="flex justify-between">
              <button  type="button" onClick={() => setOpenShippingModal(!openShippingModal)} className="w-1/2 text-left text-blue-600">Add shipping or delivery</button>
              <span className="w-1/4 text-right">{orderEastiamte.shipping_name}</span>
              <span className="w-1/4 text-right">{orderEastiamte.shipping_fee}</span>
            </div>
            <div className="flex justify-between">
              <span className="w-1/2 text-left">Estimated tax</span>
              <span className="w-1/4 text-right">{orderEastiamte.tax_type}</span>
              <span className="w-1/4 text-right">{orderEastiamte.estimated_tax}</span>
            </div>
            <div className="flex justify-between font-semibold">
              <span className="w-1/2 text-left">Total</span>
              <span className="w-1/4 text-right">{orderEastiamte.total}</span>
            </div>
          </div>
          <div className="mt-4">
            <label className="flex items-center">
              <input type="checkbox" className="form-checkbox" />
              <span className="ml-2">Payment due later</span>
            </label>
          </div>
          <div className="mt-4 flex justify-between">
            <button className="px-4 py-2 bg-white border border-gray-300 rounded">
              Send Invoice
            </button>
            <button className="px-4 py-2 bg-black text-white rounded">
              Collect payment
            </button>
          </div>
        </div>

      </NXForm>

      {openShippingModal && <ShippingChooser
        isOpen={openShippingModal}
        onClose={() => setOpenShippingModal(!openShippingModal)}
        onSubmit={onShippingApply}
        customer={customer}
      />}

      {openDiscountgModal && <DiscountChooser
        isOpen={openDiscountgModal}
        onClose={() => setOpenDiscountModal(!openDiscountgModal)}
        onSubmit={onDiscountApply}
      />}

        {openOrderDetails && <OrderDetails isOpen={openOrderDetails ? true : false} onClose={() => setOpenOrderDetails(null)} alias={openOrderDetails} />}
        
        {(openShippingAddress || openBillingAddress) && (
      <AddressForm
        defaultData={openShippingAddress ? cartItems.shipping_address : openBillingAddress ? cartItems.billing_address : {}}
        isShipping={openShippingAddress} // true if it's for shipping, false if for billing
        onSubmit={onAddressSubmit} 
        isOpen={openShippingAddress || openBillingAddress} 
        onClose={() => {
          setOpenShippingAddress(false);
          setOpenBillingAddress(false);
        }} 
      />
    )}



    </NxtbnDrawer>
  );
}

export default CreateOrderForm;
